import type { NewsItem } from "@/types/movie";

export const newsList: NewsItem[] = [
  {
    id: "news-2024-boxoffice",
    title: "2024年暑期档票房创新高，《星际征途》领跑",
    summary:
      "据最新统计，今年暑期档总票房较去年同期增长明显，科幻大片《星际征途》以强劲口碑稳居榜首，多部中小成本影片同样表现亮眼。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20crowded%20modern%20cinema%20lobby%20with%20warm%20orange%20marquee%20lights%20and%20deep%20navy%20interior%2C%20editorial%20film%20industry%20photography%20style&width=1000&height=640&seq=qx-nw-01&orientation=landscape",
    category: "行业新闻",
    source: "秋霞电影资讯中心",
    author: "编辑部",
    publishTime: "2024-08-28",
    content: [
      "随着暑期档落幕，最新公布的票房数据引发行业热议。今年暑期档总票房较去年同期实现明显增长，观影人次也创下近年来的新高，市场呈现出回暖的积极信号。",
      "其中，科幻电影《星际征途》凭借精良的制作与扎实的口碑表现，长期占据票房榜首位。影片以硬核的科幻设定和细腻的情感刻画，吸引了大量观众二刷三刷。",
      "值得关注的是，多部中小成本影片同样取得了超出预期的成绩。业内人士认为，观众的选择正变得越来越多元，优质内容不论体量大小，都能找到属于自己的市场。",
      "有分析指出，随着影院基础设施不断完善和观影习惯的回归，未来电影市场有望保持稳健增长的态势。",
    ],
  },
  {
    id: "news-festival-award",
    title: "亚洲电影大奖揭晓，《长安夜行》斩获多项大奖",
    summary:
      "本届亚洲电影大奖上，《长安夜行》凭借出色的叙事与美术设计摘得多项荣誉，成为当晚最大赢家。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20film%20award%20ceremony%20stage%20with%20warm%20orange%20spotlights%20and%20deep%20navy%20backdrop%2C%20golden%20statue%20on%20pedestal%2C%20editorial%20event%20photography%20style&width=1000&height=640&seq=qx-nw-02&orientation=landscape",
    category: "行业新闻",
    source: "秋霞电影资讯中心",
    author: "记者 林晓",
    publishTime: "2024-08-15",
    content: [
      "在刚刚落幕的亚洲电影大奖颁奖典礼上，古装悬疑电影《长安夜行》一举摘得最佳影片、最佳美术设计等多项大奖，成为当晚最受瞩目的作品。",
      "评委会在颁奖词中高度评价了影片在叙事结构与视觉美学上的突破，认为它成功地将类型元素与人文思考融合在一起。",
      "影片导演在领奖时表示，这份荣誉属于整个团队，也属于所有热爱电影、愿意走进影院的观众。",
      "业内普遍认为，本届大奖的结果反映出亚洲电影在类型探索与文化表达上日益成熟的趋势。",
    ],
  },
  {
    id: "news-animation-record",
    title: "动画电影《云端之城》连续四周票房逆跌",
    summary:
      "凭借出色的口碑发酵，《云端之城》上映后连续四周票房不降反升，成为今年动画市场的一大惊喜。",
    cover:
      "https://readdy.ai/api/search-image?query=Colorful%20animated%20film%20concept%20scene%20of%20floating%20clouds%20and%20a%20small%20airship%2C%20warm%20orange%20sunset%20with%20deep%20navy%20sky%2C%20whimsical%20editorial%20illustration%20style&width=1000&height=640&seq=qx-nw-03&orientation=landscape",
    category: "影片公告",
    source: "秋霞电影资讯中心",
    author: "编辑部",
    publishTime: "2024-08-02",
    content: [
      "动画电影《云端之城》自上映以来，凭借精美的画面与治愈的故事收获了广泛好评。令人惊喜的是，影片票房在次周后不降反升，连续四周保持增长。",
      "发行方表示，票房的逆势上扬主要得益于观众的口碑传播，许多家庭选择走进影院二刷、三刷。",
      "影片以一座漂浮在云层之上的城市为舞台，讲述了一个关于记忆与回家的温暖故事，适合全年龄段观众。",
      "有院线经理透露，影片的排片占比在口碑带动下持续提升，成为暑期档的意外黑马。",
    ],
  },
  {
    id: "news-restoration",
    title: "经典影片 4K 修复计划启动，首批名单公布",
    summary:
      "多家机构联合宣布启动经典华语影片 4K 修复计划，首批包括多部年代久远的珍贵作品，将于年内陆续重映。",
    cover:
      "https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20and%20restoration%20equipment%20on%20a%20warm-lit%20workbench%2C%20deep%20navy%20shadows%20with%20orange%20light%2C%20editorial%20archival%20photography%20style&width=1000&height=640&seq=qx-nw-04&orientation=landscape",
    category: "行业新闻",
    source: "秋霞电影资讯中心",
    author: "记者 周然",
    publishTime: "2024-07-20",
    content: [
      "日前，多家电影机构联合宣布启动新一轮经典华语影片 4K 修复计划，旨在让珍贵的影像遗产以更好的面貌重回大银幕。",
      "首批公布的修复名单涵盖了多部具有代表性的年代作品，涵盖剧情、武侠、文艺等多种类型。",
      "修复团队表示，整个修复过程不仅涉及画质提升，还需要对原始音轨进行精细处理，最大程度还原当年的观影体验。",
      "据悉，完成修复的影片将于年内陆续在部分影院重映，并同步推出线上专区，方便观众重温经典。",
    ],
  },
  {
    id: "news-teaser-release",
    title: "《深海之瞳》续集正式官宣，先导预告曝光",
    summary:
      "备受期待的《深海之瞳》续集正式确认立项，片方同步放出先导预告，短短一分钟便吊足观众胃口。",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20deep%20ocean%20trench%20with%20glowing%20bioluminescent%20lights%20and%20a%20descending%20submarine%2C%20deep%20navy%20and%20teal%20tones%2C%20editorial%20cinematic%20style&width=1000&height=640&seq=qx-nw-05&orientation=landscape",
    category: "影片公告",
    source: "秋霞电影资讯中心",
    author: "编辑部",
    publishTime: "2024-07-06",
    content: [
      "在首部作品取得票房与口碑双丰收后，《深海之瞳》续集终于正式官宣。片方在社交平台发布了先导预告，迅速登上热门话题榜。",
      "预告片中，深海的幽暗与未知再次成为视觉核心，短短一分钟的片段营造出强烈的悬念感。",
      "主创团队透露，续集将在世界观与情感深度上进一步拓展，同时保留前作最受观众喜爱的氛围营造。",
      "影片预计于明年与观众见面，更多演员阵容与上映信息将陆续公布。",
    ],
  },
  {
    id: "news-summer-festival",
    title: "城市夏日电影展落幕，超十万人次参与",
    summary:
      "为期两周的城市夏日电影展圆满落幕，露天放映、主题论坛等活动吸引了超过十万人次参与。",
    cover:
      "https://readdy.ai/api/search-image?query=Outdoor%20summer%20film%20screening%20at%20dusk%20with%20a%20large%20screen%20and%20seated%20audience%2C%20warm%20orange%20string%20lights%20and%20deep%20navy%20sky%2C%20editorial%20event%20photography%20style&width=1000&height=640&seq=qx-nw-06&orientation=landscape",
    category: "活动信息",
    source: "秋霞电影资讯中心",
    author: "记者 苏晴",
    publishTime: "2024-06-25",
    content: [
      "为期两周的城市夏日电影展日前圆满落幕。本届影展设置了露天放映、经典重映、主题论坛等多个单元，累计参与人次超过十万。",
      "露天放映单元深受市民欢迎，许多场次一票难求。观众在夏夜微风中一起观看经典影片，成为城市里独特的文化景观。",
      "主题论坛则邀请了多位影评人与创作者，围绕类型电影的创作与市场展开讨论，现场气氛热烈。",
      "主办方表示，未来将继续把影展打造为连接电影与城市生活的重要平台。",
    ],
  },
  {
    id: "news-direction-trend",
    title: "行业观察：中小成本影片如何突围",
    summary:
      "在头部大片林立的档期里，一批中小成本影片凭借清晰定位与精准营销实现了口碑与票房的双赢。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20film%20editing%20studio%20with%20warm%20desk%20lamps%20and%20deep%20navy%20walls%2C%20storyboards%20and%20monitors%2C%20editorial%20industry%20photography%20style&width=1000&height=640&seq=qx-nw-07&orientation=landscape",
    category: "行业新闻",
    source: "秋霞电影资讯中心",
    author: "特约评论员",
    publishTime: "2024-06-10",
    content: [
      "近两年，一个值得注意的现象是，部分中小成本影片在竞争激烈的档期中成功突围，取得了远超预期的市场表现。",
      "分析其成功路径，清晰的内容定位与精准的目标观众沟通是关键。相比堆砌宣传资源，这些影片更擅长用差异化的话题撬动口碑传播。",
      "此外，灵活的宣发节奏与点映策略，也让它们能够在正式上映前积累起足够的观众基础与讨论热度。",
      "可以预见，随着观众审美的日益成熟，中小成本影片将拥有更多施展空间。",
    ],
  },
  {
    id: "news-cinema-tech",
    title: "沉浸式影厅升级，观影体验再进化",
    summary:
      "多家影院完成技术升级，新一代沉浸式影厅在音画表现上大幅提升，为观众带来更具包裹感的观影体验。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20premium%20cinema%20auditorium%20with%20wide%20screen%20and%20warm%20orange%20accent%20lighting%20against%20deep%20navy%20walls%2C%20editorial%20interior%20photography%20style&width=1000&height=640&seq=qx-nw-08&orientation=landscape",
    category: "行业新闻",
    source: "秋霞电影资讯中心",
    author: "记者 林晓",
    publishTime: "2024-05-28",
    content: [
      "为了给观众带来更好的观影体验，多家影院近期完成了新一轮技术升级，推出了新一代沉浸式影厅。",
      "新影厅在画面亮度、色彩还原与声音定位上均有明显提升，配合更为科学的座椅布局，让观众的沉浸感进一步增强。",
      "有影院负责人表示，技术升级并非目的，而是为了让更多观众愿意回到影院，重新感受大银幕独有的魅力。",
      "未来，影院还将在互动体验与个性化服务上持续探索。",
    ],
  },
  {
    id: "news-director-interview",
    title: "专访《归途》导演：回家是永远的主题",
    summary:
      "在《归途》上映之际，导演分享了他对故乡、亲情与电影创作的理解，坦言这是一部写给所有游子的作品。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20portrait-style%20film%20set%20with%20director%20chair%20and%20camera%20rig%2C%20warm%20orange%20lighting%20and%20deep%20navy%20backdrop%2C%20editorial%20magazine%20photography%20style&width=1000&height=640&seq=qx-nw-09&orientation=landscape",
    category: "活动信息",
    source: "秋霞电影资讯中心",
    author: "记者 苏晴",
    publishTime: "2024-05-12",
    content: [
      "在《归途》上映之际，导演接受了本刊专访，畅谈影片创作背后的故事。",
      "谈及创作初衷，导演表示，随着自己年龄增长，越来越意识到故乡与亲情在生命中的分量，这部电影其实是一封写给所有游子的信。",
      "在叙事上，影片选择了一条克制而温暖的路线，用一路上的相遇与告别，串联起主角内心的变化。",
      "导演透露，未来他仍会继续关注普通人的情感世界，把那些容易被忽略的温柔时刻搬上银幕。",
    ],
  },
  {
    id: "news-global-market",
    title: "全球影市观察：亚洲电影影响力持续上升",
    summary:
      "近年来，亚洲电影在国际市场的表现愈发亮眼，多部作品在海外取得优异成绩，文化影响力不断扩大。",
    cover:
      "https://readdy.ai/api/search-image?query=World%20map%20made%20of%20glowing%20light%20points%20on%20a%20deep%20navy%20background%20with%20warm%20orange%20highlight%20over%20Asia%2C%20editorial%20data%20visualization%20style&width=1000&height=640&seq=qx-nw-10&orientation=landscape",
    category: "行业新闻",
    source: "秋霞电影资讯中心",
    author: "特约评论员",
    publishTime: "2024-04-30",
    content: [
      "最新数据显示，亚洲电影在全球市场的份额持续攀升，多部作品在海外票房与口碑上均取得不俗成绩。",
      "这一趋势的背后，是创作者在类型探索与文化表达上的不断突破，也是全球观众对多元故事的渴求。",
      "有评论认为，亚洲电影正逐渐从区域性影响走向更广泛的全球传播，成为世界影坛不可忽视的力量。",
      "未来，随着国际合作与发行的进一步深入，亚洲电影的影响力有望继续扩大。",
    ],
  },
  {
    id: "news-streaming-trend",
    title: "线上与影院并行，发行方式更趋多元",
    summary:
      "越来越多影片选择线上线下并行发行，灵活的模式为创作者与观众都带来了新的可能。",
    cover:
      "https://readdy.ai/api/search-image?query=Living%20room%20home%20cinema%20setup%20with%20a%20large%20screen%20and%20warm%20ambient%20lighting%2C%20deep%20navy%20walls%2C%20cozy%20editorial%20interior%20photography%20style&width=1000&height=640&seq=qx-nw-11&orientation=landscape",
    category: "行业新闻",
    source: "秋霞电影资讯中心",
    author: "编辑部",
    publishTime: "2024-04-15",
    content: [
      "线上与影院并行发行，正成为越来越多影片的选择。这种更为灵活的模式，为不同规模的作品提供了更丰富的市场空间。",
      "对于部分中小成本影片而言，线上渠道能够帮助它们触达更广泛的观众；而影院上映依然是大银幕体验不可替代的载体。",
      "业内人士认为，两种发行方式并非彼此对立，而是可以相互补充，共同构成更健康的内容生态。",
      "如何在两者之间找到平衡点，将成为未来发行策略的重要课题。",
    ],
  },
  {
    id: "news-youth-campus",
    title: "校园题材回暖，青春片迎来新表达",
    summary:
      "沉寂数年的青春校园题材近期明显回暖，一批聚焦真实成长故事的作品受到年轻观众欢迎。",
    cover:
      "https://readdy.ai/api/search-image?query=Sunny%20school%20campus%20corridor%20with%20warm%20afternoon%20light%20and%20deep%20navy%20shadows%2C%20nostalgic%20editorial%20photography%20style&width=1000&height=640&seq=qx-nw-12&orientation=landscape",
    category: "影片公告",
    source: "秋霞电影资讯中心",
    author: "记者 周然",
    publishTime: "2024-03-28",
    content: [
      "经历了一段低调期后，青春校园题材近期重新回到观众视野，多部新片取得了不错的口碑。",
      "与以往不同的是，新一代青春片更注重真实感与成长细节，减少了悬浮的戏剧性设定，转而关注普通人的情感与选择。",
      "有导演表示，青春不只有爱情，还有友情、迷茫与梦想，这些同样值得被认真讲述。",
      "观众对于真实、真诚的故事始终抱有期待，这也为青春片的创作指明了方向。",
    ],
  },
];